/**
 * * Тип файла
 */
export enum FileTypeEnum {
  /**Изображение */
  Image = "image",
  /**Видео */
  Video = "video",
  /**Другое */
  Other = "other",
}
